/**
 * Pure status → icon/class-name helpers for the pipeline/deploy and pods
 * panels, extracted out of Canvas.jsx. No component state involved — plain
 * string-in, string-out lookups.
 */

export const getPipelineStatusIcon = (status) => {
  if (!status) return '⏳';
  const statusLower = status.toLowerCase();
  const icons = {
    success: '✅',
    failed: '❌',
    running: '⏳',
    pending: '⏸️',
    canceled: '🚫',
    skipped: '⏭️'
  };
  return icons[statusLower] || '❓';
};

export const getPipelineStatusClass = (status) => {
  if (!status) return 'status-unknown';
  return `status-${status.toLowerCase()}`;
};

export const getPodStatusIcon = (status) => {
  if (!status) return '❓';
  const statusLower = status.toLowerCase();
  if (statusLower === 'running') return '✅';
  if (statusLower === 'pending') return '⏳';
  if (statusLower === 'succeeded') return '✔️';
  if (statusLower === 'failed') return '❌';
  if (statusLower === 'unknown') return '❓';
  if (statusLower === 'crashloopbackoff') return '🔄';
  if (statusLower === 'error') return '⚠️';
  return '❓';
};

export const getPodStatusClass = (status) => {
  if (!status) return 'pod-status-unknown';
  const statusLower = status.toLowerCase();
  if (statusLower === 'running') return 'pod-status-running';
  if (statusLower === 'pending') return 'pod-status-pending';
  if (statusLower === 'succeeded') return 'pod-status-succeeded';
  if (statusLower === 'failed') return 'pod-status-failed';
  if (statusLower === 'crashloopbackoff') return 'pod-status-error';
  if (statusLower === 'error') return 'pod-status-error';
  return 'pod-status-unknown';
};
